var render = function render() {
    var _vm = this, _c = _vm._self._c, _setup = _vm._self._setupProxy;
    return _c('div', {
        class: _vm.$style.navBar
    }, [
        _c('nav-bar-with-tracking', {
            attrs: {
                "left-arrow": _setup.canBack,
                "title": _setup.title,
                "z-index": 10,
                "safe-area-inset-top": "",
                "fixed": "",
                "placeholder": _vm.placeholder,
                "background": "transparent",
                "color": _vm.color,
                "border": false
            },
            on: {
                "click-left": _setup.onBack
            },
            scopedSlots: _vm._u([
                {
                    key: "background",
                    fn: function fn() {
                        return [
                            _c('div', {
                                ref: "bg",
                                class: _vm.$style.bg,
                                style: {
                                    background: _vm.background,
                                    opacity: _setup.opacity
                                }
                            })
                        ];
                    },
                    proxy: true
                },
                {
                    key: "left",
                    fn: function fn() {
                        return [
                            _vm._t("left")
                        ];
                    },
                    proxy: true
                },
                {
                    key: "right",
                    fn: function fn() {
                        return [
                            _vm._t("default")
                        ];
                    },
                    proxy: true
                }
            ], null, true)
        })
    ], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };
